
document.addEventListener('DOMContentLoaded', function () {
    // Categories dropdown functinality
    var categories = document.querySelectorAll('.js-products-listing__side-filters-categories');
    categories.forEach(function (category) {
        category.addEventListener('click', function () {
            if (!category.classList.contains('no-subcategories')) {
                var activeCategory = document.querySelector('.active');
                if (activeCategory === this) {
                    this.classList.remove('active');
                } else {
                    if (activeCategory) {
                        activeCategory.classList.remove('active');
                    }
                    this.classList.add('active');
                }
            }
        });
    });

    // Sizes
    var sizes = document.querySelectorAll('.js-products-listing__side-filters-sizes-box');
    sizes.forEach(function (size) {
        size.addEventListener('click', function () {
            this.classList.toggle('active');
        });
    });

    var lengthCups = document.querySelectorAll('.js-products-listing__side-filters-lengthcup-box');
    lengthCups.forEach(function (lengthcup) {
        lengthcup.addEventListener('click', function () {
            this.classList.toggle('active');
        });
    });

    // Colors
    var sizes = document.querySelectorAll('.js-products-listing__side-filters-colors-box');
    sizes.forEach(function (size) {
        size.addEventListener('click', function () {
            this.classList.toggle('active');
        });
    });

    // Colors
    var sizes = document.querySelectorAll('.js-products-listing__side-filters-brands-box');
    sizes.forEach(function (size) {
        size.addEventListener('click', function () {
            this.classList.toggle('active');
        });
    });

    var tags = document.querySelectorAll('.js-products-listing__side-filters-tags-box');
    tags.forEach(function (size) {
        size.addEventListener('click', function () {
            this.classList.toggle('active');
            clearanceFiltersApply()
        });
    });

    var body = document.querySelector('body');
    var filterBtn = document.querySelector('.js-product-listing__filter-btn');
    var filters = document.querySelector('.js-products-listing__side-filters');
    var filtersClose = document.querySelector('.js-products-listing__side-filters-close');
    var filtersCloseOnBackground = document.querySelector('.js-products-listing__side-filters-wrapper-background');
    filterBtn.addEventListener('click', function () {
        filters.classList.add('is-visible');
        body.classList.add('prevent-scroll');
    });
    filtersClose.addEventListener('click', function () {
        filters.classList.remove('is-visible');
        body.classList.remove('prevent-scroll');
    });
    filtersCloseOnBackground.addEventListener('click', function () {
        filters.classList.remove('is-visible');
        body.classList.remove('prevent-scroll');
    });
});

function clearanceFiltersApply() {
    let urlParams = new URLSearchParams(window.location.search);

    let tags = document.querySelectorAll('.js-products-listing__side-filters-tags-box.active');
    let tagsValues = [];

    tags.forEach(tag => {
        const tagText = tag.dataset.tag;
        if (!urlParams.getAll('filter.p.m.custom.clearance_filter').includes(tagText)) {
            urlParams.append('filter.p.m.custom.clearance_filter', tagText);
            tagsValues.push(tagText);
        }
    });

    window.location.search = urlParams;

    let filtersApplied = new URLSearchParams(window.location.search);

    filtersApplied.forEach((filter, key) => {
        if (key.includes('size')) {
            let sizeElement = document.querySelector(`.js-products-listing__side-filters-sizes-box[data-size="${filter}"]`);
            sizeElement.classList.add('active');
            let content = {
                size: filter,
                key: key
            }
            insertPill(content, 'size');
        } else if (key.includes('vendors')) {
            let vendorID = filter.replace(/^\D+/g, '');
            let vendorElement = document.querySelector(`.js-products-listing__side-filters-brands-box[data-vendor-gid="${vendorID}"]`);
            vendorElement.classList.add('active');
            let content = {
                vendorImage: vendorElement.querySelector('img'),
                key: key,
                filter: filter
            }
            insertPill(content, 'vendor')
        } else if (key.includes('lengthcup')) {
            let lengthCupElement = document.querySelector(`.js-products-listing__side-filters-lengthcup-box[data-size='${filter}']`);
            lengthCupElement.classList.add('active');
            let content = {
                lengthcup: filter,
                key: key
            }
            insertPill(content, 'lengthcup');
        } else if (key.includes('color')) {
            let colorElement = document.querySelector(`.js-products-listing__side-filters-colors-box[data-color-name="${filter}"]`);
            colorElement.classList.add('active');
            let color_hex;
            let color_type;
            if (colorElement.style.backgroundColor && !colorElement.dataset.colors && !colorElement.dataset.multicolor) {
                color_type = 'hex';
                color_hex = colorElement.style.backgroundColor;
            } else if (colorElement.style.background && colorElement.dataset.colors) {
                color_type = 'gradient';
                color_hex = colorElement.dataset.colors;
            } else if (colorElement.dataset.multicolor) {
                color_type = 'multicolor';
                color_hex = '';
            }

            let content = {
                color_type: color_type,
                color_name: filter,
                color_hex: color_hex,
                key: key
            };
            insertPill(content, 'color');
        } else if (key.includes('clearance_filter')) {
            let tagElement = document.querySelector(`.js-products-listing__side-filters-tags-box[data-tag="${filter}"]`);
            let collectionTitle = tagElement.querySelector('span').innerHTML;
            tagElement.classList.add('active');

            let content = {
                tag: filter,
                collectionTitle: collectionTitle,
                key: key
            }
            insertPill(content, 'clearance_filter');
        }
    })

    function insertPill(content, type) {
        if (type === 'color') {
            let spanEl  = ``;
            switch (content.color_type) {
                case 'hex':
                    spanEl = `<div class="products-listing__products-pill-color" style="background-color: ${content.color_hex};"></div>`;
                    break;

                case 'gradient':
                    spanEl = `<div class="products-listing__products-pill-color" style="background: linear-gradient(${content.color_hex});"></div>`;
                    break;

                case 'multicolor':
                    spanEl = `<div class="products-listing__products-pill-color" style="background: linear-gradient(#ff0000, transparent), linear-gradient(to top left, #00ff00, transparent), linear-gradient(to top right, #0000ff, transparent); background-blend-mode: screen;"></div>`;
                    break;
            }
            let html = `
            <div class="products-listing__products-pill products-listing__products-pill--alt">
                ${spanEl}
                <div class="products-listing__products-pill-text">${content.color_name}</div>
                <div class="products-listing__products-pill-close-icon js-close-icon" data-filter-key="${content.key}" data-filter-value="${content.color_name}"></div>
            </div>
            `;
            document.querySelector('.js-pills').insertAdjacentHTML('afterbegin', html);
        }
        if (type === 'size') {
            let html = `
            <div class="products-listing__products-pill">
                <span class="products-listing__products-pill-text">Size:<span>${content.size}</span>
                </span>
                <div class="products-listing__products-pill-close-icon js-close-icon" data-filter-key="${content.key}" data-filter-value="${content.size}"></div>
            </div>
            `;
            document.querySelector('.js-pills').insertAdjacentHTML('afterbegin', html);
        }
        if (type === 'lengthcup') {
            let label = content.lengthcup.includes('"') ? 'Length' : 'Cup';
            let html = `
            <div class="products-listing__products-pill">
                <span class="products-listing__products-pill-text">${label}:<span>${content.lengthcup}</span>
                </span>
                <div class="products-listing__products-pill-close-icon js-close-icon" data-filter-key="${content.key}" data-filter-value='${content.lengthcup}'></div>
            </div>
            `;
            document.querySelector('.js-pills').insertAdjacentHTML('afterbegin', html);
        }
        if (type === 'vendor') {
            let html = `
            <div class="products-listing__products-pill">
                <div class="products-listing__products-pill-logo-img">
                <img src="${content.vendorImage.src}" alt="${content.vendorImage.alt}">
                </div>
                <div class="products-listing__products-pill-close-icon js-close-icon" data-filter-key="${content.key}" data-filter-value="${content.filter}"></div>
            </div>
            `;
            document.querySelector('.js-pills').insertAdjacentHTML('afterbegin', html);
        }
        if (type === 'clearance_filter') {
            let html = `
            <div class="products-listing__products-pill">
                <span class="products-listing__products-pill-text"><span>${content.collectionTitle}</span>
                </span>
                <div class="products-listing__products-pill-close-icon js-close-icon" data-filter-key="${content.key}" data-filter-value="${content.tag}"></div>
            </div>
            `;
            document.querySelector('.js-pills').insertAdjacentHTML('afterbegin', html);
        }
    }
}

function equalizeProductTitleHeights() {
    const titles = document.querySelectorAll('.products-listing__products-list-item-title');

    if (titles.length === 0) return;

    let maxHeight = 0;
    const maxLines = 3;
    const lineHeight = parseInt(window.getComputedStyle(titles[0]).lineHeight, 10);
    const maxAllowedHeight = lineHeight * maxLines;

    titles.forEach(title => {
        title.style.height = 'auto';
        const naturalHeight = title.offsetHeight;
        if (naturalHeight > maxAllowedHeight) {
            truncateText(title, maxAllowedHeight, lineHeight);
            maxHeight = maxAllowedHeight;
        } else if (naturalHeight > maxHeight) {
            maxHeight = naturalHeight;
        }
    });

    titles.forEach(title => {
        title.style.height = `${maxHeight}px`;
    });
}

function truncateText(element, maxHeight, lineHeight) {
    const originalText = element.textContent;
    let truncatedText = originalText;

    let start = 0;
    let end = originalText.length;
    let mid;

    while (start < end) {
        mid = Math.floor((start + end) / 2);
        element.textContent = originalText.substring(0, mid) + '...';
        if (element.offsetHeight <= maxHeight) {
            start = mid + 1;
        } else {
            end = mid;
        }
    }

    element.textContent = originalText.substring(0, end - 1) + '...';
}

window.addEventListener('load', equalizeProductTitleHeights);
window.addEventListener('resize', equalizeProductTitleHeights);
